import { DateTime } from 'luxon';
import Decimal from 'decimal.js';

export function formatDate(date, short = false) {
  //'date' origin may not be knonw converting it to a timestamp is the best solution.
  //accecpts sqldate, timestamp, and string are accepted
  const timestamp = new Date(date).getTime();
  if (!(timestamp > 0)) throw new Error('Invalid Date');
  const ts = DateTime.fromMillis(timestamp);

  if (!short) return ts.toLocaleString(DateTime.DATE_FULL);
  return ts.toLocaleString(DateTime.DATE_SHORT);
}

export const formatCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  currencySign: 'accounting',
}).format;

//Adds up all of the ledgers for each account on each label with accounts
export function calculateTotals(labels) {
  return labels.map(label => ({
    ...label,
    totals: label.recoupAccounts.reduce(sumAllLabelLedger, {
      spentTotal: 0,
      recoupedTotal: 0,
      estimatedRecoupableTotal: 0,
      committedTotal: 0,
      balanceTotal: 0,
    }),
  }));
}

function sumAllLabelLedger(total, account) {
  const accountValues = account.ledgers.reduce(sumAccountLedger, { spent: 0, recouped: 0 });
  const spent = Decimal.add(total.spentTotal, accountValues.spent).toNumber();
  const estimatedRecoupable = Decimal.add(total.estimatedRecoupableTotal, account.estimated_recoupable_usd).toNumber();
  const recouped = Decimal.add(total.recoupedTotal, accountValues.recouped).toNumber();
  const committed = Decimal.add(total.committedTotal, account.committed_usd).toNumber();

  return {
    spentTotal: spent,
    recoupedTotal: recouped,
    estimatedRecoupableTotal: estimatedRecoupable,
    committedTotal: committed,
    balanceTotal: Decimal.add(committed, spent).toNumber(),
  };
}

export function sumAccountLedger(sum, ledger) {
  if (ledger.voided) return { spent: sum.spent, recouped: sum.recouped };
  if (Number(ledger.amount_usd) > 0)
    return { spent: sum.spent, recouped: Decimal.add(sum.recouped, ledger.amount_usd).toNumber() };
  if (Number(ledger.amount_usd) <= 0)
    return { spent: Decimal.add(sum.spent, ledger.amount_usd).toNumber(), recouped: sum.recouped };
}
